export default {"src":"/_next/static/media/apteliyz.2522550d.svg","height":27,"width":79,"blurWidth":0,"blurHeight":0};